export enum SituacaoNF {
    Autorizada = 2,
    Rejeitada = 3,
    Cancelada = 4,
    Denegada = 5,
    Inutilizada = 6,
    Contingencia = 7,
}


export const getDescricaoSituacaoNF = (value) => {
    switch (parseInt(value)) {
      case 2:
        return 'Autorizada';
      case 3:
        return 'Rejeitada';
      case 4:
        return 'Cancelada';
      case 5:
        return 'Denegada';
      case 6:
        return 'Inutilizada';
      case 7:
        return 'Contingência';
      case 9:
        return 'Recibo';
      case 10:
        return 'Pendente';
    }
  };